import { render, staticRenderFns } from "./purchase-request.vue?vue&type=template&id=67f0df9a&"
import script from "./purchase-request.vue?vue&type=script&lang=js&"
export * from "./purchase-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports